import type { ReactNode } from "react";

import { Typography } from "antd";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ThemeToggle } from "sandbox/features/shared/ThemeToggle";
import { useSandboxLogo } from "sandbox/hooks";

import s from "./AuthCardLayout.module.css";

interface AuthCardLayoutProps {
  children: ReactNode;
  wide?: boolean;
}

export const AuthCardLayout = ({ children, wide }: AuthCardLayoutProps) => {
  const { t } = useTranslation("sandbox");
  const logo = useSandboxLogo();

  return (
    <section className={s.page}>
      <header className={s.header}>
        <img src={logo} alt="Thredd" className={s.logo} />
        <span className={s.brandPill}>{t("components.header.brandPill")}</span>
        <ThemeToggle className={s.themeToggle} />
      </header>
      <div className={s.body}>
        <div className={clsx(s.card, wide && s.cardWide)}>{children}</div>
        <Typography.Paragraph className={s.fineprint}>
          {t("auth.fineprint")}
        </Typography.Paragraph>
      </div>
    </section>
  );
};
